import variables from '@/assets/styles/element-variables.scss'
import defaultSettings from '@/settings'

const {
  tagsView, fixedHeader, sidebarLogo, uniqueOpened, showFooter, footerTxt,
  caseNumber, dsCaseNumber, yxjfCaseNumber, swCaseNumber, mhCaseNumber, rhCaseNumber,
  zyCaseNumber, ybCaseNumber, faCaseNumber, yxCaseNumber, mwCaseNumber,
  lkCaseNumber, jsCaseNumber,fzmhCaseNumber,hlCaseNumber,ztCaseNumber,hmCaseNumber,gbCaseNumber,dlCaseNumber,nxCaseNumber,ssCaseNumber

} = defaultSettings

const state = {
  theme: variables.theme,
  showSettings: false,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  uniqueOpened: uniqueOpened,
  showFooter: showFooter,
  footerTxt: footerTxt,
  caseNumber: caseNumber,
  dsCaseNumber: dsCaseNumber,
  yxjfCaseNumber: yxjfCaseNumber,
  swCaseNumber: swCaseNumber,
  mhCaseNumber: mhCaseNumber,
  rhCaseNumber: rhCaseNumber,
  zyCaseNumber: zyCaseNumber,
  ybCaseNumber: ybCaseNumber,
  faCaseNumber: faCaseNumber,
  fzmhCaseNumber: fzmhCaseNumber,
  yxCaseNumber: yxCaseNumber,
  mwCaseNumber: mwCaseNumber,
  lkCaseNumber: lkCaseNumber,
  jsCaseNumber: jsCaseNumber,
  hlCaseNumber: hlCaseNumber,
  ztCaseNumber: ztCaseNumber,
  hmCaseNumber: hmCaseNumber,
  gbCaseNumber: gbCaseNumber,
  dlCaseNumber: dlCaseNumber,
  nxCaseNumber: nxCaseNumber,
  ssCaseNumber: ssCaseNumber
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

